export default function VideoLoader() {
  return (
    <div className="absolute inset-0 flex items-center justify-center z-10">
      <div className="h-6 w-6 rounded-full border-2 border-white/30 border-t-white animate-spin" />
    </div>
  )
}
